import { Coffee, ArrowUp } from 'lucide-react'

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-coffee-900 text-cream py-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="font-heading text-3xl font-bold">KV</span>
              <span className="font-body text-lg text-coffee-300">Studio</span>
            </div>
            <p className="text-coffee-300 leading-relaxed max-w-sm mb-6">
              Marketing, ami felébreszti a vállalkozásod. Weboldal készítés, 
              Google Ads, Social Media és SEO szolgáltatások.
            </p>
            <div className="flex items-center gap-2 text-coffee-400">
              <Coffee size={18} />
              <span className="text-sm">Mi adjuk a marketinged koffeinjét</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Szolgáltatások</h4>
            <ul className="space-y-3">
              <li>
                <a href="#szolgaltatasok" className="text-coffee-300 hover:text-cream transition-colors">
                  Weboldal készítés
                </a>
              </li>
              <li>
                <a href="#szolgaltatasok" className="text-coffee-300 hover:text-cream transition-colors">
                  Google Ads
                </a>
              </li>
              <li>
                <a href="#szolgaltatasok" className="text-coffee-300 hover:text-cream transition-colors">
                  Social Media
                </a>
              </li>
              <li>
                <a href="#szolgaltatasok" className="text-coffee-300 hover:text-cream transition-colors">
                  SEO
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold mb-4">Kapcsolat</h4>
            <ul className="space-y-3 text-coffee-300">
              <li>
                <a href="mailto:info@kvstudio.hu" className="hover:text-cream transition-colors">
                  info@kvstudio.hu
                </a>
              </li>
              <li>
                <a href="tel:+36301234567" className="hover:text-cream transition-colors">
                  +36 30 123 4567
                </a>
              </li>
              <li>Budapest, Magyarország</li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-coffee-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-coffee-400 text-sm">
            © {currentYear} KV Studio - Varga Krisztina. Minden jog fenntartva.
          </p>
          <button
            onClick={scrollToTop}
            className="flex items-center gap-2 text-coffee-400 hover:text-cream transition-colors group"
            data-testid="scroll-to-top"
            aria-label="Scroll to top"
          >
            <span className="text-sm">Vissza a tetejére</span>
            <div className="w-8 h-8 bg-coffee-800 rounded-full flex items-center justify-center group-hover:bg-coffee-700 transition-colors">
              <ArrowUp size={16} />
            </div>
          </button>
        </div>
      </div>
    </footer>
  )
}

export default Footer
